var _dec, _dec2, _dec3, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { BeanBase, Virtual } from 'zova';
import { Bean } from 'zova-module-a-bean';
export let BeanApiBase = (_dec = Bean(), _dec2 = Virtual(), _dec3 = __z_BeanInfo({
  module: "a-api"
}), _dec(_class = _dec2(_class = _dec3(_class = class BeanApiBase extends BeanBase {
  $pathTranslate(pathName, pathParams) {
    return this.sys.util.apiActionPathTranslate(pathName, pathParams);
  }
  $configPrepare(baseURL, options, authToken) {
    return this.sys.util.apiActionConfigPrepare(baseURL, options, authToken);
  }
  $formData(body) {
    const formData = new FormData();
    for (const key in body) {
      const value = body[key];
      if (Array.isArray(value)) {
        for (const item of value) {
          formData.append(key, item);
        }
      } else {
        formData.append(key, value);
      }
    }
    return formData;
  }
}) || _class) || _class) || _class);